

















































































































































































































































































import Workspaces from './Services/Workspaces.vue';

export default {
	name: 'Users',
	components: {
		Workspaces,
	},
	data() {
		const validateMail: Function = (rule, value, callback) => {
			if (this.isEditing) return callback();
			for (const el of this.users) {
				if (el.email === value) return callback(new Error('error'));
			}
			return callback();
		};
		return {
			isEditing: false,
			userForm: {
				firstName: '',
				lastName: '',
				email: '',
				area: '',
				role: '',
				inactive: false,
				disableSupport: true,
				permission: '',
				admin: false,
			},
			currentPage: 1,
			currentSelection: {},
			userDrawer: false,
			loading: false,
			formLabelWidth: '120px',
			permissions: {
				full: this.$t('users.permissions.full'),
				intermediate: this.$t('users.permissions.intermediate'),
				basic: this.$t('users.permissions.basic'),
			},
			workspaceDrawer: false,
			innerDrawer: false,
			rules: {
				email: [
					{ required: true, message: this.$t('users.validation.emailRequired'), trigger: ['blur', 'change'] },
					{ type: 'email', message: this.$t('users.validation.emailInvalid'), trigger: ['blur', 'change'] },
					{ validator: validateMail, message: this.$t('users.validation.emailTaken'), trigger: 'blur' },
				],
				firstName: [
					{ required: true, message: this.$t('users.validation.firstNameRequired'), trigger: ['blur', 'change'] },
				],
				lastName: [
					{ required: true, message: this.$t('users.validation.lastNameRequired'), trigger: ['blur', 'change'] },
				],
				permission: [{ required: true, message: this.$t('users.validation.permissionRequired'), trigger: 'change' }],
				area: [{ required: true, message: this.$t('users.validation.teamRequired'), trigger: 'change' }],
				role: [{ required: true, message: this.$t('users.validation.workspaceRequired'), trigger: 'change' }],
			},
		};
	},
	computed: {
		organizationPath(): string {
			return this.$store.getters.path;
		},
		users(): object[] {
			const users = this.$store.state.users || [];
			const emailInvites = this.$store.state.organization.emailInvitations || [];
			return [...users, ...emailInvites];
		},
		lastAdmin(): Boolean {
			return this.$store.state.users.filter(user => user.admin).length === 1;
		},
		workspaces(): any {
			return this.$store.state.workspaces;
		},
		departments(): any {
			return this.$store.state.departments;
		},
		roles(): any {
			let department = this.$store.state.departments.find(el => el.id === this.userForm.area);
			return department && department.roles;
		},
		drawerData(): object[] {
			if (!this.currentSelection.id) return [];
			const department = this.departments.find(el => el.id === this.currentSelection.area);
			const roleWorkspace = department
				? this.workspaces[department.roles.find(el => el.id === this.currentSelection.role).id].filter(
						el => el.type !== 'config'
				  )
				: [];
			roleWorkspace.forEach(e => (e.role = true));
			const userWorkspace =
				this.currentSelection.permission !== 'basic'
					? this.workspaces[this.currentSelection.id].filter(
							el =>
								el.type !== 'config' && !(this.currentSelection.permission === 'intermediate' && el.key === 'dashboard')
					  )
					: [];
			return [...roleWorkspace, ...userWorkspace].sort((a, b) =>
				a.type === 'group' ? -1 : b.type === 'group' ? 1 : 0
			);
		},
	},
	watch: {
		'userForm.email'(newValue, oldValue) {
			if (newValue === oldValue) return;
			this.userForm.email = newValue.toLowerCase();
		},
	},
	methods: {
		onPermissionChange(value) {
			value === 'full' && (this.userForm = { ...this.userForm, area: '', role: '' });
		},
		handleSizeChange(val) {
			console.log(`${val} items per page`);
		},
		handleCurrentChange(val) {
			console.log(`current page: ${val}`);
		},
		async validateForm(): Promise<boolean> {
			try {
				return await this.$refs.userForm.validate();
			} catch (error) {
				return false;
			}
		},
		async sendEmailInvitation() {
			const valid = await this.validateForm();

			if (!valid) return;
			try {
				this.loading = true;
				const result = await this.$store.dispatch('sendEmailInvitation', { user: this.userForm });
				this.loading = false;

				this.$refs.userDrawer.closeDrawer();

				this.$message({
					type: 'success',
					message: this.$t('users.emailSent'),
				});
			} catch (error) {
				this.loading = false;
				console.log(error);

				this.$message({
					type: 'error',
					message: this.$translateError(error),
				});
			}
		},
		reSendInvitation(row) {
			this.$msgbox({
				title: this.$t('users.resendTitle'),
				message: this.$t('users.resendMessage'),
				showCancelButton: true,
				confirmButtonText: this.$t('common.ok'),
				cancelButtonText: this.$t('common.cancel'),
				beforeClose: async (action, instance, done) => {
					if (action === 'confirm') {
						instance.confirmButtonLoading = true;
						instance.confirmButtonText = this.$t('common.sending');
						try {
							await this.$store.dispatch('sendEmailInvitation', { user: row, resend: true });
						} catch (error) {
							this.$message({
								type: 'error',
								message: this.$translateError(error),
							});
						}
						instance.confirmButtonLoading = false;
					}
					done();
				},
			})
				.then(action => {
					this.$message({
						type: 'success',
						message: this.$t('users.emailSent'),
					});
				})
				.catch(e => {});
		},
		editUser(row: any, column: any, index: number): void {
			this.isEditing = true;
			this.userDrawer = true;
			this.userForm = {
				id: row.id,
				firstName: row.firstName,
				lastName: row.lastName,
				email: row.email,
				permission: row.permission,
				area: row.area,
				role: row.role,
				inactive: row.inactive,
				disableSupport: row.disableSupport,
				admin: row.admin,
			};
		},
		async onEditUser(): Promise<void> {
			const originalUser = this.users.find(el => el.id === this.userForm.id);
			let differentData = false;

			[
				'id',
				'firstName',
				'lastName',
				'email',
				'permission',
				'area',
				'role',
				'inactive',
				'disableSupport',
				'admin',
			].forEach(key => originalUser[key] !== this.userForm[key] && (differentData = true));

			if (!differentData) return this.$refs.userDrawer.closeDrawer();

			const valid = await this.validateForm();
			if (!valid) return;
			this.loading = true;

			const data = { path: this.organizationPath, user: { ...this.userForm }, workspaceVersion: '2.0.0' };

			try {
				originalUser['permission'] !== 'basic' &&
					this.userForm['permission'] === 'basic' &&
					(await this.$confirm(this.$t('users.basicPermissionWarning'), this.$t('common.warning'), {
						confirmButtonText: this.$t('common.ok'),
						cancelButtonText: this.$t('common.cancel'),
						type: 'warning',
					}));

				await this.$firebase.functions().httpsCallable('editUser')(data);
				this.loading = false;
				this.$refs.userDrawer.closeDrawer();

				this.$message({
					type: 'success',
					message: this.$t('users.userEdited'),
				});
			} catch (error) {
				this.loading = false;
				console.log(error);

				this.$message({
					type: 'error',
					message: this.$translateError(error),
				});
			}
		},
		deleteUser(row) {
			const h = this.$createElement;
			this.$msgbox({
				title: row.id ? this.$t('users.deleteUserTitle') : this.$t('users.deleteInvitationTitle'),
				message: h('p', null, [
					h(
						'span',
						null,
						row.id
							? this.$t('users.deleteUserConfirm', { name: `${row.firstName} ${row.lastName}` })
							: this.$t('users.deleteInvitationConfirm', { email: row.email })
					),
				]),
				showCancelButton: true,
				confirmButtonText: this.$t('common.delete'),
				cancelButtonText: this.$t('common.cancel'),
				beforeClose: async (action, instance, done) => {
					if (action !== 'confirm') return done();
					instance.confirmButtonLoading = true;
					instance.confirmButtonText = this.$t('common.deleting');
					try {
						if (row.id) {
							const data = {
								email: row.email,
								path: this.organizationPath,
								tenantId: this.$store.state.user.tenantId,
								admin: row.admin,
								stripe: this.$store.state.organization.stripe,
							};
							const response = await this.$firebase.functions().httpsCallable('deleteUser')(data);
						} else {
							const response = await this.$firebase.functions().httpsCallable('deleteEmailInvitation')({
								path: this.organizationPath,
								data: row,
							});
						}
						this.loading = false;
						this.$message({
							type: 'success',
							message: this.$t('users.deleteCompleted'),
						});
						instance.confirmButtonLoading = false;
					} catch (error) {
						instance.confirmButtonLoading = false;
						this.loading = false;
						console.log(error);

						this.$message({
							type: 'error',
							message: this.$translateError(error),
						});
					}
					done();
				},
			});
		},
		clearUserForm(): object {
			return {
				firstName: '',
				lastName: '',
				email: '',
				area: '',
				role: '',
				inactive: false,
				disableSupport: false,
				permission: '',
			};
		},
		onCloseDrawer(done) {
			this.isEditing = false;
			this.userForm = this.clearUserForm();
			this.$refs.userForm.resetFields();
			done();
		},
		viewWorkspace(row) {
			this.currentSelection = row;
			this.workspaceDrawer = true;
		},
		onCloseForm(): void {
			this.workspaceDrawer = false;
			this.currentSelection = {};
		},
		formatterDepartments(row, column) {
			const department = this.$store.state.departments.find(el => el.id === row.area);
			return department ? department.name : '-';
		},
		formatterRoles(row, column) {
			const department = this.$store.state.departments.find(el => el.id === row.area);
			const role = department && department.roles.find(el => el.id === row.role);
			return role ? role.name : '-';
		},
		formatterPermission(row, column) {
			return this.permissions[row.permission];
		},
	},
};
